export const getValueFromChangeEvent = args => args[0].target.value;
export const changeCallbackCaller = (cb, args) => cb(args[0]);



// WEBPACK FOOTER //
// ./src/utils/index.js